import React from "react";
import { useAuthOrg } from "./AuthOrgContext";

// Re-export useAuthOrg as useAuth for backward compatibility
export const useAuth = useAuthOrg;

// Deprecated AuthProvider - just renders children
// This allows us to remove it from App.tsx without breaking imports immediately if we wanted,
// but we will remove it from App.tsx anyway.
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};
